import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { NgbAccordionModule, NgbModalModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { EllipsisModule } from 'ngx-ellipsis';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { SwiperModule } from 'swiper/angular';

import { CategoriesComponent } from './components/categories/categories.component';
import { FooterComponent } from './components/footer/footer.component';
import { InstagramCarouselComponent } from './components/instagram-carousel/instagram-carousel.component';
import { NewProductCardComponent } from './components/new-product-card/new-product-card.component';
import { NewsletterComponent } from './components/newsletter/newsletter.component';
import { OurProductsComponent } from './components/our-products/our-products.component';
import { ProductCardComponent } from './components/product-card/product-card.component';
import { ProductsComponent } from './components/products/products.component';
import { ReviewCardComponent } from './components/review-card/review-card.component';
import { ReviewsComponent } from './components/reviews/reviews.component';
import { SliderBannerComponent } from './components/slider-banner/slider-banner.component';
import { CarouselModule, CategoriesModule, HeaderModule, NewsletterModule, OwnBrandsValuesModule } from '@infrab4a/components-b4a';
import { ResultsComponent } from './components/results/results.component';
import { ResultCardComponent } from './components/result-card/result-card.component';

const COMPONENTS = [
  FooterComponent,
  NewsletterComponent,
  SliderBannerComponent,
  OurProductsComponent,
  ProductCardComponent,
  ProductsComponent,
  NewProductCardComponent,
  ReviewCardComponent,
  ReviewsComponent,
  CategoriesComponent,
  InstagramCarouselComponent,
  ResultsComponent,
  ResultCardComponent
];

@NgModule({
  declarations: COMPONENTS,
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    SwiperModule,
    NgxSkeletonLoaderModule,
    EllipsisModule,
    NgbModule,
    NgbAccordionModule,
    NgbModalModule,
    CarouselModule,
    BrowserAnimationsModule,
    CarouselModule,
    OwnBrandsValuesModule,
    CategoriesModule,
    NewsletterModule,
    HeaderModule
  ],
  exports: [
    COMPONENTS,
    NgbModule,
    NgbAccordionModule,
    NgbModalModule,
    CarouselModule,
    BrowserAnimationsModule,
  ],
})
export class SharedModule {}
